<div
  class="cmx-navbar__legal-entity"
  [ngClass]="{
    'cmx-navbar__legal-entity--mobile': isMobile,
    'cmx-navbar__legal-entity--collapsed': !isMobile && isCollapsed,
    'cmx-navbar__legal-entity--rtl-collapsed': !isMobile && isRtl && isCollapsed
  }"
  (click)="toggleLegalEntityList()"
>
  <div class="cmx-navbar__legal-entity-name">{{ (legalEntity.legalEntityActive | async)?.legalEntityDesc }}</div>
  <div class="cmx-navbar__legal-entity-id">
    #{{ (legalEntity.legalEntityActive | async)?.legalEntityTypeCode }}
    <span
      *ngIf="!isRtl"
      class="cmx-navbar__legal-entity-toggle cmx-icon-right-single"
      [ngClass]="{ 'cmx-navbar__legal-entity-toggle--open': isLegalEntityListOpen }"
    ></span>
    <span
      *ngIf="isRtl"
      class="cmx-navbar__legal-entity-toggle cmx-icon-left-single"
      [ngClass]="{ 'cmx-navbar__legal-entity-toggle--rtl-open': isLegalEntityListOpen }"
    ></span>
  </div>
</div>
